import { ILocationNode } from 'types/locationsRegistry.interface'
import { minToHHMM } from 'utils/coverageStatus'

export interface ICoverageNamedOption {
  id: number
  name: string
}

export interface ICoverageShiftOption {
  shiftId: number
  name: string
  windowFrom: string
  windowTo: string
  shiftStart: number
  minutes: number
}

export const coverageSitesFromTree = (tree: ILocationNode | null | undefined): ICoverageNamedOption[] => {
  if (!tree) return []
  const roots = tree.id === 0 && Array.isArray(tree.children) ? tree.children : [tree]
  return roots
    .filter((n) => n && n.id)
    .map((n) => ({ id: n.id, name: n.name }))
}

export const flattenLocationNodes = (
  node: ILocationNode | null | undefined,
  siteNodeId: number,
  acc: ICoverageNamedOption[] = [],
): ICoverageNamedOption[] => {
  if (!node) return acc
  if (node.id && node.id !== siteNodeId) {
    acc.push({ id: node.id, name: node.name })
  }
  ;(node.children || []).forEach((child) => flattenLocationNodes(child, siteNodeId, acc))
  return acc
}

export const coverageLocationsForSite = (
  tree: ILocationNode | null | undefined,
  siteNodeId: number,
): ICoverageNamedOption[] => {
  if (!tree) return []
  const roots = tree.id === 0 && Array.isArray(tree.children) ? tree.children : [tree]
  const site = roots.find((n) => n.id === siteNodeId) || null
  return flattenLocationNodes(site, siteNodeId, [])
}

export const mapShiftsToCoverageOptions = (
  shifts: { id: number; name: string; shiftStart: number; minutes: number }[],
): ICoverageShiftOption[] =>
  (shifts || []).map((s) => ({
    shiftId: s.id,
    name: s.name,
    shiftStart: s.shiftStart,
    minutes: s.minutes,
    windowFrom: minToHHMM(s.shiftStart),
    windowTo: minToHHMM(s.shiftStart + s.minutes),
  }))
